import { Col } from 'reactstrap';
import styled from 'styled-components';

export const ColStyled = styled(Col)`
    margin-bottom: 25px;

    & > div {

        &:last-child {
            margin-bottom: 0;
            height: 100%;
        }
    }
`;
ColStyled.displayName = 'ColStyled';

export const PanelSectionLateral = styled.div`
    margin-bottom: 25px;

    & > div > div {
        border-right: thin solid ${ ({ theme: { disabledColor } }) => disabledColor };

        &:last-child {
            border-right: none;
        }
    }
`;
PanelSectionLateral.displayName = 'PanelSectionLateral';

export const ButtonContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: auto;
`;

export const RatingContainer = styled.div`
    margin-top: auto;
`;
